interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  action?: React.ReactNode;
}

export default function EmptyState({ icon = "ri-inbox-line", title, description, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-100 px-6 py-16 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-200 text-foreground-500">
        <i className={`${icon} text-3xl`}></i>
      </span>
      <h3 className="mt-4 font-heading text-base font-bold text-foreground-900">{title}</h3>
      {description && <p className="mt-1.5 max-w-sm text-sm text-foreground-500">{description}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}